import React from 'react';
import { injectIntl, FormattedMessage } from '../../util/reactIntl';
import css from './InvoiceDetails.css';

const InvoiceDetails = ({ invoiceData, intl }) => {
  if (!invoiceData) {
    return (
      <p className={css.noData}>
        <FormattedMessage id="InvoiceDetails.noData" />
      </p>
    );
  }

  const { companyName, name, taxId, address, zip, city, country, customerType } = invoiceData;
  const isCompany = customerType === 'company' || customerType === 'business';

  return (
    <div className={css.container}>
      <div className={css.mainInfo}>
        <p className={css.clientName}>
          {isCompany ? companyName : name}
        </p>
        {isCompany && taxId && (
          <span className={css.taxId}>
            {intl.formatMessage({ id: 'InvoiceDetails.taxIdLabel' })}: {taxId}
          </span>
        )}
      </div>

      <p className={css.addressLine}>{address}</p>
      <p className={css.addressLine}>{zip} {city}</p>
      <p className={css.countryLine}>{country}</p>

      <div className={css.badgeRow}>
        <span className={css.typeBadge}>
          {isCompany ? (
            <FormattedMessage id="InvoiceDetails.typeCompany" />
          ) : (
            <FormattedMessage id="InvoiceDetails.typeIndividual" />
          )}
        </span>
      </div>
    </div>
  );
};

export default injectIntl(InvoiceDetails);